import { Platform } from 'react-native'
import { NoticeBannerStack } from '@/ui/NoticeBannerStack'
import { NoticeToastList } from '@/ui/NoticeToastList'

export function NoticeRenderer() {
    return Platform.OS === 'web' ? <NoticeToastList /> : <NoticeBannerStack />
}
